import { lazy } from 'react';

import MinimalLayout from 'components/layout/MinimalLayout';
import Loadable from 'components/ui/Loadable';
import AuthGuard from 'utils/routeGuard/AuthGuard';

const SetupCompanyPage = Loadable(lazy(() => import('components/pages/SetupCompany')));

const LoggedInRoutesMinimal = {
  path: '',
  element: (
    <AuthGuard>
      <MinimalLayout />
    </AuthGuard>
  ),
  children: [{ path: '/setup-company', element: <SetupCompanyPage /> }]
};

export default LoggedInRoutesMinimal;
